import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";

// Bootstrap dinamico con code-splitting REALE: le route pubbliche Charme Gift
// caricano solo l'entry leggero (GiftPublicEntry), NON l'intero gestionale.
const root = ReactDOM.createRoot(document.getElementById("root"));
const path = window.location.pathname;
const isGift = path.startsWith("/gift/") || path.startsWith("/gift-preview/")
  || path.startsWith("/g/") || path.startsWith("/g-preview/")
  || path.startsWith("/gift-card/") || path.startsWith("/gc/");

const loader = isGift
  ? import("@/GiftPublicEntry")
  : import("@/App");

loader.then(({ default: RootComponent }) => {
  root.render(
    <React.StrictMode>
      <RootComponent />
    </React.StrictMode>,
  );
});
